<template>
    <div>
        <div v-for="(allErrors, idx) in errorsForField" :key="idx">
            <small class="text-danger">{{ allErrors}} </small>
        </div>
    </div>
</template>

<script>
export default {
    name: "validation-errors",
    props: ['errors', 'field'],
    computed: {
        errorsForField() {

            if (!this.errors) {
                return [];
            }

            for (const key in this.errors) {
                if (this.errors.hasOwnProperty(key) && key === this.field) {
                    return this.errors[this.field];
                }
            }
            return [];
        }
    }
}
</script>
